import {
  Heading,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalOverlay,
  ModalProps,
  Text,
  VStack,
} from "@chakra-ui/react";

type SimplePopupProps = ModalProps & {
  title: string;
  description?: string;
  isClosable?: boolean;
  hasScrollArea?: boolean;
};

const SimplePopup = ({
  title,
  description,
  size,
  isClosable = true,
  hasScrollArea = false,
  children,
  ...rest
}: SimplePopupProps) => {
  return (
    <Modal {...rest}>
      <ModalOverlay />
      <ModalContent
        w={size}
        maxH={hasScrollArea ? "calc(100vh - 2rem)" : ""}
        my={hasScrollArea ? "0" : "6"}
      >
        {isClosable && <ModalCloseButton />}

        <ModalBody
          py="6"
          px="0"
          display="flex"
          flexDir="column"
          maxH="full"
          overflow="auto"
        >
          <VStack w="full" pt="4" spacing="2" textAlign="center">
            <Heading fontSize="2xl" fontWeight="bold" maxW="18rem">
              {title}
            </Heading>

            <Text fontSize="sm" opacity="0.8" maxW="18rem">
              {description}
            </Text>
          </VStack>

          {children}
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default SimplePopup;
